import { z } from "zod/v3";
import { ZodOutputFor, createSchema } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { PlanTrainUnitDetailsResponse as ProtoPlanTrainUnitDetailsResponse } from "@opstel/gen/knop/ui/v1/api/plan_train_unit_details_pb";
import {
  PlanTrainUnitDetails,
  PlanTrainUnitDetailsSchema,
} from "../models/planTrainUnitDetails/planTrainUnitDetails";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface PlanTrainUnitDetailsResponse {
  planTrainUnitDetailsList: PlanTrainUnitDetails[];
  message: string;
  status: ResponseStatus;
}

export const planTrainUnitDetailsResponseSchema = createSchema<
  PlanTrainUnitDetailsResponse,
  PlainMessage<ProtoPlanTrainUnitDetailsResponse>
>({
  planTrainUnitDetailsList: z.array(PlanTrainUnitDetailsSchema),
  message: z.string(),
  status: responseStatusSchema,
}) as ZodOutputFor<PlanTrainUnitDetailsResponse>;

export function parseServiceTaskData(
  proto: PlainMessage<ProtoPlanTrainUnitDetailsResponse>,
): PlanTrainUnitDetailsResponse {
  return planTrainUnitDetailsResponseSchema.parse(proto);
}
